import { createAsyncThunk } from "@reduxjs/toolkit";
import { userId } from "src/helpers/user_id";
import { apiClient } from '../../helpers/api_helper';

/*
export const getObjectives = createAsyncThunk("objectives/getObjectives", async () => {
    try {
      const response = await apiClient.get(`/project/objectives/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
*/

export const addObjectives = createAsyncThunk("objectives/addObjectives", async (objectives: any) => {
    try {
      const response = await apiClient.post(`/project/objectives/`,{
          quantidade: Number(objectives.quantidade_prevista),
          unidade: objectives.unidade,
          projecto: Number(objectives.project_id),
          create_user: 1,
          update_user: 1,
        });
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateObjectives = createAsyncThunk("objectives/updateObjectives", async (objectives: any) => {
    try {
      const response = await apiClient.put(`/project/objectives/${objectives.id}/`,{
          quantidade: objectives.quantidade,
          unidade_id: objectives.unidade_id,
          project_id: objectives.project_id,
          create_user: userId,
          update_user: userId,
        });
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteObjectives = createAsyncThunk("objectives/deleteObjectives", async (objectivesId: any) => {
    try {
      const response = await apiClient.delete(`/project/objectives/${objectivesId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getObjectivesByProject = createAsyncThunk("objectives/getObjectivesByProject", async (projectId: any) => {
    try {
      const response = await apiClient.get(`/project/objectives/get-objectives-by-project-id/${projectId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
